import { useState, useLayoutEffect, useEffect } from 'react';

function useSize(element) {
  const [size, setSize] = useState(void 0);
  useLayoutEffect(() => {
    if (element === null) {
      return;
    }
    const rect = element.getBoundingClientRect();
    setSize({
      width: rect.width,
      height: rect.height
    });
  }, [element]);
  useEffect(() => {
    if (element === null) {
      return;
    }
    const resizeObserver = new ResizeObserver((entries) => {
      if (!Array.isArray(entries)) {
        return;
      }
      if (entries.length === 0) {
        return;
      }
      const entry = entries[0];
      if (entry === void 0) {
        console.warn(
          "[packages/hooks-browser] entry === undefined \uC778 \uC0C1\uD669\uC774 \uC758\uB3C4\uC778\uC9C0 \uD655\uC778\uD574 \uC8FC\uC138\uC694."
        );
      }
      let width;
      let height;
      if ("borderBoxSize" in entry) {
        const borderSizeEntry = entry["borderBoxSize"];
        const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
        width = borderSize["inlineSize"];
        height = borderSize["blockSize"];
      } else {
        const rect = element.getBoundingClientRect();
        width = rect.width;
        height = rect.height;
      }
      setSize({ width, height });
    });
    resizeObserver.observe(element, { box: "border-box" });
    return () => resizeObserver.unobserve(element);
  }, [element]);
  return size;
}

export { useSize as default };
//# sourceMappingURL=useSize.mjs.map
